import React from "react";
import { Building2, ShieldCheck } from "lucide-react";

import Modal from "../common/Modal";
import Input from "../common/Input";

function WorkspaceModal({ form, setForm, creating, onClose, onSubmit }) {
  return (
  <Modal
    title="Create workspace"
    description="Add a new workspace to your account."
    icon={Building2}
    onClose={onClose}
    onSubmit={onSubmit}
    submitting={creating}
    submitText="Create workspace"
  >
    <div className="space-y-4">
      <Input
        label="Workspace name"
        name="name"
        placeholder="e.g. Auto Appy"
        icon={Building2}
        value={form.name}
        onChange={(event) =>
          setForm((previous) => ({
            ...previous,
            name: event.target.value,
          }))
        }
        disabled={creating}
      />

      <div className="flex items-start gap-3 rounded-xl border border-theme-200 bg-theme-50 px-3 py-3 dark:border-dark-border dark:bg-dark-soft-blue">
        <ShieldCheck size={16} className="mt-0.5 shrink-0 text-primary dark:text-dark-primary"/>

        <div>
          <p className="text-[10px] font-semibold text-primary dark:text-dark-primary">
            Workspace isolation
          </p>

          <p className="mt-0.5 text-[10px] leading-5 text-text-secondary dark:text-dark-text-secondary">
            Each workspace can have its own WhatsApp Business accounts, phone
            numbers and configuration.
          </p>
        </div>
      </div>
    </div>
  </Modal>
);
}

export default WorkspaceModal;
